<template>
  <form-row
    v-if="isLeadgen"
    :is-vertical-splitted="false"
  >
    <div class="direct-marketing">
      <checkbox-square
        v-model="directMarketingEmail"
        name="direct-marketing-all"
        class="direct-marketing__all"
        data-test="direct_marketing_email"
        data-unit-test="direct-marketing-email"
        @change="(value) => changeOption('directMarketingEmail', value)"
      >
        <slot>Yes please</slot>
      </checkbox-square>
    </div>
  </form-row>
  <form-row
    v-else
    :is-vertical-splitted="false"
  >
    <marketing-options
      type="direct"
      :check-all-value="checkAllValue"
      :options-value="optionsValue"
      :options-list="marketingOptionsList"
      @change-option="({option, value}) => changeOption(option, value)"
    />
  </form-row>
</template>

<script>
import MarketingOptions from '@/components/marketingOptions/MarketingOptions';

export default {
  name: 'direct-marketing-option',
  components: {
    MarketingOptions,
  },
  inject: [
    'isLeadgen',
    'constants',
    'config',
  ],
  props: {
    optionsValue: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      directMarketingEmail: this.optionsValue.directMarketingEmail,
    };
  },
  computed: {
    isCompareNiPartner () {
      return this.constants.PARTNERS.CompareNI.includes(this.config.partner);
    },
    partnerLabel () {
      // Temporary solution till it will be implemented in Nova
      if (this.isCompareNiPartner) {
        return 'CompareNI';
      }

      return 'Quotezone';
    },
    marketingOptionsList () {
      return Object.keys(this.constants.DIRECT_MARKETING_OPTIONS);
    },
    checkAllValue () {
      return this.constants.DIRECT_MARKETING_OPTIONS_FIELDS.every(field => this.optionsValue[field]);
    },
  },
  methods: {
    changeOption (option, value) {
      if (option === 'all') {
        const fields = [...this.constants.DIRECT_MARKETING_OPTIONS_FIELDS];

        this.$emit('change-option', { fields, value });
        return;
      }

      this.$emit('change-option', { option, value });
    },
  },
};
</script>
